const baseApiUrl = 'https://abraham-industries.sintra-soh.com';
const apiUrl = `${baseApiUrl}/api/`;
const graphQlUrl = `${baseApiUrl}/pimcore-graphql-webservices/webapp`;

export const environment = {
  production: false,
  name: 'abraham-production',
  appName: 'SOH - App Retail for Abraham Industries',
  storageVersion: '1.0.0',
  baseApiUrl,
  apiUrl,
  graphQlUrl,
  authInterceptorUrls: [apiUrl, graphQlUrl],
  mockApiUrl: 'https://localhost:3002/',
  logUrl: '',
  sockets: { url: '' },
  tokenExpirationTimeLimit: 600000, // 10 minutes
  httpRetryConfig: {
    enabled: true,
    verbs: {
      get: { enabled: true, timeout: 30000, maxRetries: 2, retryForStatusesCodes: [500] },
      post: { enabled: false, timeout: null, maxRetries: 1, retryForStatusesCodes: [500] },
      patch: { enabled: false, timeout: null, maxRetries: 1, retryForStatusesCodes: [500] },
      put: { enabled: false, timeout: null, maxRetries: 1, retryForStatusesCodes: [500] },
      delete: { enabled: false, timeout: null, maxRetries: 1, retryForStatusesCodes: [500] },
    },
  },
  graphQlConfig: {
    enabled: true,
    requestTimeout: 10000,
  },
  loggerConfig: {
    enabled: true,
    maxLogRentention: 20,
    logHttpErrorsWithStatusesCodes: ['0', '4XX', '5XX'],
    logDecoratedExceptions: true,
    logExceptions: true,
    saveLogMessagesInterval: 30000,
    logUrl: '',
    sendLogs: false,
    sendRequestBody: true,
    sendQueryParams: true,
  },
  tagManager: {
    enabled: false,
    apiKey: '',
  },
  registerServiceWorker: true,
  httpPassword: 'SOHub4Demo',
  mainLogoUrl: '',
  customerLogoUrl: '/assets/logo/abraham_logo.png',
  apiProperties: {
    size: 'iDesTg',
    sizeQuery: 'iDesTg',
    color: 'color',
    colorQuery: 'color',
  },
  returns: {
    isModuleEnabled: true,
    enableReturnedStatusButton: false,
    hideRefundInfoSection: true,
  },
  clickCollect: {
    isModuleEnabled: true,
    showClickCollectCode: true,
    enableShipFromStoreResearch: true,
  },
  shipFromStore: {
    isModuleEnabled: true,
  },
};
